import '../../../features/attributes/attributes-dashboard-widget.less'
import './pieChartWidget.less'
import NoSensitiveDataSvg from '../../../assets/inlineSvg/noData.svg'
import ChartPie from '../../../components/ChartPie/chartPie'
import LoaderView from '../../../components/Loader/loader'
import React from 'react'
import { useIntl } from 'react-intl'
import { Button, Typography } from '@lightbeamai/design-system'
import { useHistory } from 'react-router-dom'

interface OwnProps {
  parentUrl?: string
  dataSourceId?: string
  legendPosition?: 'bottom' | 'right'
  piClass?: string
  showListLegend?: boolean
  chartSize?: number
  isAnimated?: boolean
  isHighSensitive?: boolean
  title?: string
  help?: React.ReactNode | string
  showAllAttributes?: boolean
  className?: string
  isClickable?: boolean
  useMockData?: boolean
  widgetDashboardId?: string

  data: any[]
  showLoader: boolean
  showSummary?: boolean
  Summary?: any

  viewAllBtnText?: string
  viewAllLink?: string
  totalText?: string
  noDataText?: string
}

interface StateProps {
  topList?: any[]
}

type PieChartWidgetProps = StateProps & OwnProps

const PieChartWidget = (props: PieChartWidgetProps): React.ReactElement => {
  const {
    data,
    showLoader,
    legendPosition = 'top',
    piClass = 'xs-mb-36 xs-mt-36',
    chartSize = 150,
    isAnimated = true,
    title,
    help,
    className,
    isClickable = true,
    showSummary = false,
    Summary,
    viewAllBtnText,
    viewAllLink,
    totalText,
    noDataText
  } = props
  const intl = useIntl()
  const history = useHistory()

  return (
    <div className="pie-chart-widget lb-widget-card xs-p-16">
      <div className={`${className} attribute-dashboard-widget-v2-container`}>
        <div className="dashboard-container-title xs-mb-0">
          <Typography as="span" variant="h6" color="primary" className="text-transform-initial">
            {title} &nbsp;
          </Typography>
        </div>
        <div className="align-start">
          {showSummary ? <>{Summary}</> : <></>}
          <div className="full-flex">
            {help ? (
              <Typography
                variant="baseMinus4"
                color="primary"
                className="text-transform-initial xs-mt-8"
              >
                {help}
              </Typography>
            ) : (
              <></>
            )}

            <div
              data-test-id="attributes-attributes-dashboard-widget"
              className={`attributes widget-v2-grouped ${
                legendPosition === 'bottom' ? 'vertical' : 'horizontal'
              }`}
            >
              {data.length ? (
                <div className="chart-wrapper">
                  <ChartPie
                    data={data
                      .sort((a, b) => b.value - a.value)
                      .slice()
                      .reverse()}
                    link={data}
                    width={chartSize}
                    centerCountStyles={{ fontSize: '2.1rem', fontWeight: 700 }}
                    totalLink={viewAllLink}
                    className={piClass}
                    isAnimated={isAnimated}
                    isClickable={isClickable}
                    text={totalText}
                  />
                </div>
              ) : null}
              <div className={data.length ? 'legend' : 'empty-legend'}>
                {data.length ? (
                  <>
                    {data.map((item, i) => {
                      const goToFilterPage = () => history.push(item.link)
                      const formattedCount = intl.formatNumber(item.value, { notation: 'compact' })
                      // const formattedExtraValue = intl.formatNumber(item.extraValue ?? 0, {
                      //   notation: 'compact'
                      // })

                      return (
                        <div className="item btn" key={i} onClick={goToFilterPage}>
                          <div className="item-container">
                            <div className="circle" style={{ backgroundColor: item.color }} />
                            <Typography
                              as="span"
                              variant="baseMinus2"
                              color="primary"
                              className="key"
                            >
                              {item.key}
                            </Typography>
                          </div>

                          <Typography
                            as="span"
                            variant="baseMinus2"
                            color="primary"
                            type="strong"
                            className="value"
                          >
                            {legendPosition === 'bottom' ? `(${formattedCount})` : formattedCount}
                            {/* {hasColumns && hasInstances ? ` (${formattedExtraValue})` : ''} */}
                          </Typography>
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <div className="icon-box empty-state-text xs-mt-64">
                    <NoSensitiveDataSvg />
                    <Typography variant={'baseMinus2'}>
                      {noDataText || intl.formatMessage({ id: 'noDataFound' })}
                    </Typography>
                  </div>
                )}
              </div>
              <LoaderView showLoader={showLoader} size="small" />
            </div>
            <Button variant="link" href={viewAllLink || ''}>
              {viewAllBtnText || intl.formatMessage({ id: 'notifications.viewAll' })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PieChartWidget
